/**
 * Demo / Playground mode utilities.
 *
 * The demo account (demo@musterix.com) acts as a read-only playground:
 *  - All data is fetched normally from the database.
 *  - Mutations (assign, delete, create, update) are intercepted and applied
 *    only to local React state – the database is never modified.
 *  - On sign-out (or page refresh) React state resets and the next login
 *    loads the original seed data again.
 */

export const DEMO_EMAIL = 'demo@musterix.com';
export const DEMO_COMPANY_ID = 'd70b144b-867a-4853-84b4-5bbbc86eadfa';

/** Returns true when the current session belongs to the demo account. */
export function isDemoEmail(email: string | null | undefined): boolean {
  return email?.toLowerCase() === DEMO_EMAIL;
}
